export var decode = function (str) {
  return global.atob(str);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/amazon-cognito-auth-js/es/DecodingHelper.js
// module id = ./node_modules/amazon-cognito-auth-js/es/DecodingHelper.js
// module chunks = 0